import { apiService } from "../services/api.service";
import { authenticationService } from "../services/authentication.service";

export const nahlasenieDodavkyController = {
    getNahlasenieDodavky,
    getNahlasenieBaliky,
    getNahlasenieRozdiely,
    getBalikyByIdDodavka,
    opravitNesuladPoradi,
    zrusitUkoncenieBalika,
    getDodavkyProRucniNahlasenie,
    nahlaseniDodavkyDachser,
    ulozitANahlasitKusy,
    doprijemBalikov,
    doprijemBalikovOtvoreni,
    getDodavkaById,
    nahlaseniPresuny,
    getDetailNahlasenie,
    getNahlasenieDachser,
    getNahlasenaDodavkaInfo
};

function getNahlasenieDodavky() {
    return apiService.fetchApiRequest("api/NahlasenieDodavky/GetNahlasenieDodavky");
}

function getNahlasenieBaliky(idNahlasenie) {
    return apiService.fetchApiRequest("api/NahlasenieDodavky/GetNahlasenieBaliky?idNahlasenie=" + idNahlasenie);
}

function getNahlasenieRozdiely(idNahlasenie) {
    return apiService.fetchApiRequest("api/NahlasenieDodavky/GetNahlasenieRozdiely?idNahlasenie=" + idNahlasenie);
}

function getBalikyByIdDodavka(idDodavka, typRazeni) {
    return apiService.fetchApiRequest(`api/NahlasenieDodavky/GetBalikyByIdDodavka?idDodavka=${idDodavka}&typRazeni=${typRazeni}`);
}

function opravitNesuladPoradi(idDodavka) {
    return apiService.fetchApiRequest(`api/NahlasenieDodavky/OpravitNesuladPoradi?idDodavka=${idDodavka}`);
}

function zrusitUkoncenieBalika(idBalik, packing) {
    return apiService.fetchApiRequest(`api/NahlasenieDodavky/ZrusitUkoncenieBalika?idBalik=${idBalik}&packing=${packing}`);
}

function getDodavkyProRucniNahlasenie() {
    return apiService.fetchApiRequest("api/NahlasenieDodavky/GetDodavkyProRucniNahlasenie");
}

function nahlaseniDodavkyDachser(idExpedicie, cisloDodavky, skladFrom) {
    return apiService.fetchApiRequest(
        `api/NahlasenieDodavky/NahlasitDodavkuDachser?idExpedicie=${idExpedicie}&cisloDodavky=${cisloDodavky}&skladFrom=${skladFrom}`
    );
}

function ulozitANahlasitKusy(dodavka) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(dodavka)
    };
    return apiService.fetchApiRequest("api/NahlasenieDodavky/UlozitANahlasitKusy", false, requestOptions);
}

function doprijemBalikov(idDodavky) {
    return apiService.fetchApiRequest("api/NahlasenieDodavky/DoprijemBalikov?idDodavky=" + idDodavky);
}

function doprijemBalikovOtvoreni(dodavka) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(dodavka)
    };
    return apiService.fetchApiRequest("api/NahlasenieDodavky/DoprijemBalikovOtvoreni", false, requestOptions);
}

function getDodavkaById(idDodavka) {
    return apiService.fetchApiRequest("api/NahlasenieDodavky/GetSklDodavkaById?idDodavka=" + idDodavka);
}

function nahlaseniPresuny(preNovaNahlasenie, idExpedicie, cisloDodavky, skladFrom) {
    return apiService.fetchApiRequest(
        `api/NahlasenieDodavky/NahlasitPresuny?idExpedicie=${idExpedicie}&cisloDodavky=${cisloDodavky}&skladFrom=${skladFrom}&preNovaNahlasenie=${preNovaNahlasenie}`
    );
}

function getDetailNahlasenie(idExpedicie, cisloDodavky, skladFrom, idNahlasenie) {
    return apiService.fetchApiRequest(
        `api/NahlasenieDodavky/GetDetailNahlasenie?idExpedicie=${idExpedicie}&cisloDodavky=${cisloDodavky}&skladFrom=${skladFrom}&idNahlasenie=${idNahlasenie}`
    );
}

function getNahlasenieDachser(idExpedicie, cisloDodavky, skladFrom) {
    return apiService.fetchApiRequest(
        `api/NahlasenieDodavky/GetNahlasenieDachser?idExpedicie=${idExpedicie}&cisloDodavky=${cisloDodavky}&skladFrom=${skladFrom}`
    );
}

function getNahlasenaDodavkaInfo(idDodavka, skladFrom) {
    return apiService.fetchApiRequest(`api/NahlasenieDodavky/GetNahlasenaDodavkaInfo?idDodavka=${idDodavka}&skladFrom=${skladFrom}`);
}



// WEBPACK FOOTER //
// ./src/controllers/nahlaseniedodavky.controller.js